import React, { useState } from "react";
import { projectsData } from "../ProjectsData";
import "../style/Projects.css";

function Projects() {
  const [selectedCategory, setSelectedCategory] = useState("All");

  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
  };

  const categories = ["All", "iOS", "Python", "Machine Learning"];

  const filteredProjects = selectedCategory === "All" 
    ? projectsData 
    : projectsData.filter(project => project.category === selectedCategory);

  const sortedProjects = filteredProjects.sort((a, b) => b.year - a.year);

  return (
    <div className="projects-container">
      <h2 className="projects-title">My Projects</h2>

      <div className="categories">
        {categories.map((category) => (
          <button
            key={category}
            className={selectedCategory === category ? "active" : ""}
            onClick={() => handleCategoryClick(category)}
          >
            {category}
          </button>
        ))}
      </div>

      <div className="projects-grid">
        {sortedProjects.map((project) => (
          <div className="project-card" key={project.id}>
            <img
              src={project.image}
              alt={project.title}
              className="project-image"
            />

            <div className="project-info">
              <h3 className="project-title">{project.title}</h3>
              <p className="project-description">{project.description}</p>
              <div className="project-links">
                <a href={project.github} className="project-link">
                  <i className="fab fa-github"></i>GitHub
                </a>
                {project.demo && (
                  <a href={project.demo} className="project-link">
                    <i className="fas fa-external-link-alt"></i>Demo
                  </a>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Projects;
